import { useState } from 'preact/hooks';
import { api } from '../api/client';
import type { IVendorBackground } from '../types';

interface Props {
    vendorCode: number;
    vendorName: string;
}

export default function VendorBackgroundTooltip({ vendorCode, vendorName }: Props) {
    const [data, setData] = useState<IVendorBackground[] | null>(null);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const handleOpen = async () => {
        setOpen(true);
        if (data) return;
        setLoading(true);
        try {
            const result = await api.getVendorBackground(vendorCode);
            setData(result);
        } catch { setData([]); }
        setLoading(false);
    };

    // dd-mm-yyyy из ISO-строки (без пересчёта таймзоны, чтобы не было сдвига на день)
    const fmtDate = (s: string | null | undefined) => {
        if (!s) return '—';
        const m = String(s).match(/^(\d{4})-(\d{2})-(\d{2})/);
        return m ? `${m[3]}-${m[2]}-${m[1]}` : String(s);
    };
    // округление до целого (Oracle отдаёт числа строками вида "1646.00")
    const intVal = (v: any) => {
        const n = Number(v);
        return Number.isFinite(n) ? Math.round(n) : null;
    };

    return (
        <div className="relative">
            <button className="btn btn-sm btn-ghost" onClick={handleOpen} title={`Поставки: ${vendorName}`}>
                Поставки
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            </button>

            {open && (
                <div className="fixed inset-0 bg-black/30 z-50 flex items-center justify-center" onClick={() => setOpen(false)}>
                    <div className="bg-base-100 rounded-lg shadow-xl max-w-2xl w-full max-h-[70vh] flex flex-col" onClick={e => e.stopPropagation()}>
                        <div className="p-4 border-b border-base-300 flex justify-between items-center">
                            <h3 className="font-semibold">История поставщика: {vendorName}</h3>
                            <button className="btn btn-ghost btn-xs" onClick={() => setOpen(false)}>✕</button>
                        </div>
                        <div className="flex-1 overflow-auto p-4">
                            {loading ? (
                                <div className="text-center py-8"><span className="loading loading-spinner" /></div>
                            ) : !data || data.length === 0 ? (
                                <div className="text-center py-8 text-base-content/60">Нет данных</div>
                            ) : (
                                <table className="table table-xs w-full">
                                    <thead>
                                        <tr>
                                            <th>№ поставки</th><th>Дата</th><th>Кол-во</th>
                                            <th>Сумма ЗЦ</th><th>Сумма РЦ</th><th>Наценка</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map(row => (
                                            <tr key={row.code}>
                                                <td>{intVal(row.num_supply) ?? '—'}</td>
                                                <td>{fmtDate(row.dat_po_supply)}</td>
                                                <td>{intVal(row.quantity)?.toLocaleString('ru') ?? '—'}</td>
                                                <td>{row.purchase_summa?.toLocaleString('ru')}</td>
                                                <td>{row.selling_summa?.toLocaleString('ru')}</td>
                                                <td>{intVal(row.add_percent) != null ? `${intVal(row.add_percent)}%` : '—'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
